import { Injectable } from '@angular/core';
import { SmartyCubeStorageKeys } from '../config/smartycube-storage-keys';
import { LocalStorageService } from '@smartera/core';

@Injectable()
export class ThemeService {
	constructor(private localStorage: LocalStorageService) {
		const theme = this.getUserTheme();
		this.setTheme(theme);
	}

	public getDefaultTheme(): string {
		return 'saga-blue';
	}

	public getUserTheme(): string {
		return this.localStorage.getItem(SmartyCubeStorageKeys.THEME) ?? this.getDefaultTheme();
	}

	public setTheme(theme: string): void {
		const themeLink = document.getElementById('app-theme') as HTMLLinkElement | null;
		if (themeLink) {
			themeLink.href = theme + '.css';
		}
		this.prepareTheme(theme);
		this.localStorage.setItem(SmartyCubeStorageKeys.THEME, theme);
	}

	private prepareTheme(theme: string): void {
		if (theme === 'saga-blue') {
			document.body.classList.remove('dark_mode');
			document.body.classList.add('light_mode');
		} else if (theme === 'lara-dark-blue') {
			document.body.classList.remove('light_mode');
			document.body.classList.add('dark_mode');
		}
	}
}
